import { Routes } from '@angular/router';
import { NotFoundComponent } from '@app/pages/not-found/not-found.component';
import { MsalGuard } from '@azure/msal-angular';
import { ngxPermissionsGuard } from 'ngx-permissions';

import { userRoleType } from './core/models';
import { LayoutComponent } from './layout/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/pages/auth/home.component').then((c) => c.HomeComponent),
    title: 'Panel administrativo',
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('@app/pages/dashboard/dashboard.component').then((c) => c.DashboardComponent),
        title: 'Dashboard',
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            except: [userRoleType.GUEST],
            redirectTo: '/acceso-restringido',
          },
        },
      },
      {
        path: 'perfil',
        loadComponent: () => import('@app/pages/profile/profile.component').then((c) => c.ProfileComponent),
        title: 'Perfil',
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            except: [userRoleType.GUEST],
            redirectTo: '/acceso-restringido',
          },
        },
      },
      {
        path: 'companies',
        loadChildren: () => import('@app/pages/companies/companies.routing'),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [userRoleType.VALIDADOR, userRoleType.TECNICO, userRoleType.SOPORTE, userRoleType.VISOR],
            redirectTo: '/acceso-restringido',
          },
        },
      },
      {
        path: 'allies',
        loadChildren: () => import('@app/pages/allies/allies.routing'),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              userRoleType.TECNICO,
              userRoleType.ROL_BACKOFFICE_VISOR,
              userRoleType.ROL_BACKOFFICE_ADMIN,
              userRoleType.ROL_BACKOFFICE_LOCATIONCREATE,
              userRoleType.BACKOFFICE_CREADOR_CREDENCIALES,
            ],
            redirectTo: '/acceso-restringido',
          },
        },
      },
      {
        path: 'events',
        loadChildren: () => import('@app/pages/events/events.routing'),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [userRoleType.GESTOR_CAMPANAS, userRoleType.TECNICO, userRoleType.SOPORTE, userRoleType.VISOR],
            redirectTo: '/acceso-restringido',
          },
        },
      },
      {
        path: 'automatic-accruals',
        loadChildren: () => import('@app/pages/automatic-accruals/automatic-accrual.routing'),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [userRoleType.TECNICO, userRoleType.SOPORTE, userRoleType.VISOR, userRoleType.ADMINISTRADOR_AA],
            redirectTo: '/acceso-restringido',
          },
        },
      },
      {
        path: 'media-services',
        loadChildren: () => import('@app/pages/media-services/media-services.routing'),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [userRoleType.MEDIA, userRoleType.TECNICO, userRoleType.VISOR, userRoleType.ROL_BACKOFFICE_ADMIN],
            redirectTo: '/acceso-restringido',
          },
        },
      },
      {
        path: 'campaings',
        loadChildren: () => import('@app/pages/campaings/campaing.routing'),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              userRoleType.MEDIA,
              userRoleType.TECNICO,
              userRoleType.ROL_BACKOFFICE_VISOR,
              userRoleType.ROL_BACKOFFICE_ADMIN,
              userRoleType.BACKOFFICE_AUDIENCE_CALCULATE,
            ],
            redirectTo: '/acceso-restringido',
          },
        },
      },
      {
        path: 'inquiry-fraud',
        loadChildren: () => import('@app/pages/frauds/inquiry-fraud/inquiry-fraud.routing'),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              userRoleType.ROL_FRAUDE,
              userRoleType.ROL_BACKOFFICE_VISOR,
              userRoleType.TECNICO,
              userRoleType.ROL_BACKOFFICE_ADMIN,
            ],
            redirectTo: '/acceso-restringido',
          },
        },
      },
    ],
  },
  {
    path: 'login-failed',
    loadComponent: () => import('@app/pages/login-failed/login-failed.component').then((c) => c.LoginFailedComponent),
  },

  {
    path: 'acceso-restringido',
    loadComponent: () =>
      import('@pages/restricted-access/restricted-access.component').then((c) => c.RestrictedAccessComponent),
  },

  // Wildcard route for a 404 page
  { path: '**', component: NotFoundComponent },
];
